import { render, staticRenderFns } from "./MenuPrincipal.vue?vue&type=template&id=cb98edf8&scoped=true&"
import script from "./MenuPrincipal.vue?vue&type=script&lang=js&"
export * from "./MenuPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./MenuPrincipal.vue?vue&type=style&index=0&id=cb98edf8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb98edf8",
  null
  
)

export default component.exports